module.exports = __webpack_public_path__ + "static/dcd7e5f5.setting.webp";